import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
    url: 'https://pilot1.nazza.nl/auth/',
    realm: 'nazza',
    clientId: 'reservation-web'
});

export default keycloak;